import React, { useState, useEffect } from "react";
import { getReq, delReq, postReq } from "../middleware/AxiosApisCall";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg";
import { AiFillDelete } from "react-icons/ai";
import { MdModeEditOutline } from "react-icons/md";

import Loading from "../Loading";
function TableDataWithPagination(props) {
  const [tableData, setTableData] = useState([]);
  const { machineID } = props;
  // 
  const [searchData, setSearchData] = useState(props.searchData);
  const [load, setLoad] = useState(false)
  const [page, setPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [metadata, setMetaData] = useState();
  const [maxpagelimit, setMaxPageLimit] = useState();
  const [tableRefresh,setTableRefresh]=useState(0)
  
  const loadTableDate = async () => {

        if (machineID) {
      const response = await getReq(
        `${props.path}/Table/${machineID}/${page}/${dataPerPage}`
        );
      
      setTableRefresh(tableRefresh+1)
      setLoad(true)
      if (response.data?.metadata) {
        setTableData(response.data?.data);
        setMetaData(response.data?.metadata);
        // loadDate();
      } else {
        // 
        setTableData([]);
        setMetaData(null);
      }
    } else {
      const response = await getReq(`${props.path}/Table/${page}/${dataPerPage}`);
      setLoad(true)
      if (response.data?.metadata) {
        const data=response.data?.data
        const sortedData=data.sort((a,b)=>{
          return new Date(a.createdAt) - new Date(b.createdAt)
        })
        setTableData(sortedData);
        setMetaData(response.data?.metadata);
        // loadDate();
        setTableRefresh(tableRefresh+1)
      } else {
        // 
        setTableData([]);
        setMetaData(null);
      }
    }
  };

  // 
  const loadSearchData = async () => {
    //TODO:Submit Search Form
    if (props.reject) {
      // 
      setTableData(searchData);
      let metadat2 = {
        count: searchData.length,
        start: 1,
        end: searchData.length,
        page: 1,
      };

      setMetaData(metadat2);
    } else {
      // 
      const response = await postReq(
        `${props.path}/Search/${page}/${dataPerPage}`,
        searchData
      );
      if (response?.data) {
        setTableData(response.data?.data);
        setMetaData(response.data?.metadata);
        setLoad(true)
      } else {
        props.clear();
      }
    }
    // 
  };
  const deleteState = async (event) => {
    const shouldDelete = window.confirm("Are you sure to delete this item ?");
    // 
    if (!shouldDelete) {

      return;
    }
    const response = await delReq(props.path, event);
    if (response.success) {
      loadTableDate();
      SuccessAlert({
        title: "Data Deleted",
        message: `${props.path} : Delete Succesfully `,
      });
    } else {
      ErrorAlert({
        title: `${props.path} Delete: Error`,
        message: response.msg,
      });
    }
  };
  const editClick = (item) => {
    props.editClick(item);
  };

  //TODO:Pagination Functions
  const previouspage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const nextpage = () => {
    if (page < maxpagelimit) {
      setPage(page + 1);
    }
  };
  const lastpage = () => {
    // 
    setPage(maxpagelimit);
  };

  const setdataperpage = (event) => {
    if (event.target.value <= metadata.count && event.target.value > 0) {
      setDataPerPage(event.target.value);
    }
  };

  // useEffect(()=>{
  //   loadTableDate()
  // })

  // useEffect(() => {  24
  //   if (searchData) {
  //   } else {
  //     loadTableDate();
  //   }
  // }, [machineID]);

  useEffect(() => {
    // 
    if (searchData) {
    
      setSearchData(props.searchData);
    } else setSearchData();
  }, [props.searchData]);

  //TODO:PAnination useEffects
  useEffect(() => {
    if (metadata) {
      if (metadata.count % dataPerPage) {
        setMaxPageLimit(parseInt(metadata.count / dataPerPage) + 1);
      } else {
        setMaxPageLimit(metadata.count / dataPerPage);
      }
      if (dataPerPage > metadata.count) {
        setDataPerPage(metadata.count);
      }
    }

  }, [metadata]);

  useEffect(() => {
    if (searchData) {
      loadSearchData();
    } else {
      loadTableDate();
    }
  }, [page, dataPerPage, searchData,machineID]);

  return (
    <React.Fragment>
      <div className="componet-sub2-title">
        <div className="justi-spacebt">
          <span>
            Total {props.name}: {metadata != null ? metadata.count : 0}
          </span>
          <div>
            {/* <label >Search</label> */}
            <input className="search-field" placeholder="Search..." />
          </div>
          <div className="table-page-nav-btn">
            <div className="table-data-per-page">
              <input
                type="number"
                value={dataPerPage || ""}
                onChange={
                  setdataperpage
                }
              />
            </div>
            <button
              onClick={() => {
                setPage(1);
              }}
            >
              &lt;&lt;
            </button>
            <button onClick={previouspage}>&lt;</button>
            <span>
              {metadata &&
                `${metadata.start} to ${metadata.start + tableData.length - 1
                } of ${metadata.count}`}
            </span>
            <button onClick={nextpage}>&gt;</button>
            <button onClick={lastpage}>&gt;&gt;</button>
          </div>
        </div>
      </div>
      {load ? (<div className="table_container-div">
        <table>
          <tbody>
            <tr>
              {tableData?.length > 0 ? (
                Object.keys(tableData[0]).map(
                  (key) =>
                    key !== ("_id" || null) && (
                      <th key={key}>
                        <span style={{ textTransform: "capitalize" }}>
                          {key}
                        </span>
                      </th>
                    )
                )
              ) : (
                <td></td>
              )}
              {tableData?.length > 0 && !("error" in tableData[0]) && (
                <th>Actions</th>
              )}
            </tr>

            {tableData?.length > 0 ? (
              tableData.map((item) => {
                // 
                return (
                  <tr key={item._id}>
                    {Object.keys(item)
                      .filter((i) => i !== "_id")
                      .map((input, index) => {
                        return (
                          <td
                            className={input === "error" ? "red-text" : ""}
                            key={index}
                          >
                            {item[input]}
                          </td>
                        );
                      })}

                    {props.par !== item._id ? (
                      <td>
                        <MdModeEditOutline
                          className="Edit-icon"

                          onClick={() => editClick(item)}
                        />
                        <AiFillDelete
                          className="Delete-icon"
                          onClick={() => deleteState(item._id)}
                        />
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td> Data Not Found </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>) : (<Loading />)}
    </React.Fragment>
  );
}

export default TableDataWithPagination;
